import React from 'react';
import { has, is } from '../../../services';
import clsx from 'clsx';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Radio List Component
 * @param children {ReactNode} RadioList children
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 * @param centered {boolean} Centered radios
 * @param vertical {boolean} Verical radios
 * @param isMobile {boolean} espect mobile screen
 */
const RadioList = ({ className, centered, isMobile, vertical, ...others }) => {
    const { styled } = useTrilogyContext();
    return (React.createElement("div", { className: hashClass(styled, clsx('radios', className, centered && has('text-centered'), isMobile && is('mobile'), vertical && is('vertical'))), ...others }));
};
export default RadioList;
//# sourceMappingURL=RadioList.js.map